import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Typography } from '@material-tailwind/react';

export default function Paginacion({ configuracion, paginar }) {
    return (
        <div className='flex items-center justify-end gap-3'>
            {configuracion.mostrar && configuracion.mostrarMenos ? (
                <button
                    type='button'
                    title='Anterior'
                    className='flex items-center justify-center w-8 h-8 rounded border border-gray-300 bg-white hover:bg-gray-100 hover:text-blue-600 active:bg-gray-200 focus:outline-none focus:ring-0 text-gray-600 transition-colors shadow-sm cursor-pointer'
                    onClick={() => paginar(configuracion.iMenos, configuracion.fMenos)}
                >
                    <FontAwesomeIcon icon={faAngleLeft} className='text-sm' />
                </button>
            ) : (
                <div className='w-8 h-8'></div>
            )}

            <Typography variant='small' className='font-semibold text-gray-600 mb-0 mt-0'>
                {configuracion.iIni + 1} - {configuracion.iFin + 1}
            </Typography>

            {configuracion.mostrar && configuracion.mostrarMas ? (
                <button
                    type='button'
                    title='Siguiente'
                    className='flex items-center justify-center w-8 h-8 rounded border border-gray-300 bg-white hover:bg-gray-100 hover:text-blue-600 active:bg-gray-200 focus:outline-none focus:ring-0 text-gray-600 transition-colors shadow-sm cursor-pointer'
                    onClick={() => paginar(configuracion.iMas, configuracion.fMas)}
                >
                    <FontAwesomeIcon icon={faAngleRight} className='text-sm' />
                </button>
            ) : (
                <div className='w-8 h-8'></div>
            )}
        </div>
    );
}
